import { Match } from "../../match/domain/entities/userUnjabbed";
import { SharedPriority } from "../data/RelationshipPrioritiesDataSource";
import { Heart } from "../../../core/icons/Heart";
import { Report } from "../../../core/icons/Flag";

export const MeaningfulIntroductionModal = ({
  match,
  priorities,
  onClose,
  onReport,
}: {
  match: Match;
  priorities: SharedPriority[];
  onClose: () => void;
  onReport: () => void;
}) => {
  const image = match.profile_pictures?.[0];
  const imageUrl = typeof image === "string" ? image : image?.url;
  const firstName = match.username.split(" ")[0];

  return (
    <div
      className="fixed inset-0 z-50 overflow-y-auto bg-white"
      role="dialog"
      aria-modal="true"
      aria-labelledby="meaningful-introduction-title"
    >
      <header className="sticky top-0 z-20 flex min-h-[64px] items-center justify-between bg-white px-4 shadow-sm md:px-6">
        <button
          type="button"
          onClick={onClose}
          className="flex h-10 w-10 items-center justify-center rounded-full hover:bg-grayLight"
          aria-label="Back"
        >
          <svg
            className="h-7 w-7"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            aria-hidden="true"
          >
            <path d="m15 18-6-6 6-6" />
            <path d="M9 12h11" />
          </svg>
        </button>
        <h2
          id="meaningful-introduction-title"
          className="min-w-0 flex-1 px-3 text-center text-lg font-bold md:text-xl"
        >
          Today's meaningful introduction
        </h2>
        <button
          type="button"
          onClick={onReport}
          className="flex h-10 w-10 items-center justify-center"
          aria-label="Report profile"
        >
          <Report color="#E50AAC" size={26} />
        </button>
      </header>

      <div className="mx-auto w-full max-w-2xl">
        <div className="relative bg-black">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={match.username}
              className="h-[390px] w-full object-cover md:h-[520px]"
            />
          ) : (
            <div className="h-[390px] w-full bg-grayLight md:h-[520px]" />
          )}
          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-b from-transparent to-black/75 px-5 pb-5 pt-24">
            <h3 className="text-3xl font-bold text-white">
              {match.username}, {match.age}
            </h3>
          </div>
        </div>

        <div className="p-5 md:px-8 md:py-7">
          <h4 className="text-xl font-bold md:text-2xl">Why you may connect</h4>
          <div className="mt-3">
            {priorities.map((priority) => (
              <div key={priority.key} className="flex items-center gap-3 py-3">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary">
                    <Heart className="h-4 w-4" />
                  </span>
                </span>
                <span className="text-base">{priority.label}</span>
              </div>
            ))}
          </div>
          <p className="mt-3 text-sm text-graySecondary">
            Based only on priorities you both chose to share.
          </p>
          <button
            type="button"
            onClick={onClose}
            className="mt-6 w-full rounded-lg bg-primary px-4 py-3 font-bold text-white"
          >
            View {firstName}'s profile
          </button>
          <button
            type="button"
            onClick={onClose}
            className="mt-2 w-full rounded-lg px-4 py-3 font-semibold text-primary hover:bg-primary/5"
          >
            Keep browsing
          </button>
        </div>
      </div>
    </div>
  );
};
